export default function ShipIcon() {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.4"
        d="M5.92492 5.46673L13.4416 2.9584C16.8166 1.8334 18.6499 3.67507 17.5333 7.05007L15.0249 14.5667C13.3416 19.6251 10.5749 19.6251 8.89159 14.5667L8.14992 12.3334L5.91659 11.5917C0.866586 9.91674 0.866586 7.1584 5.92492 5.46673Z"
        fill="currentColor"
      />
      <path d="M10.1001 10.1916L13.2751 7.0083L10.1001 10.1916Z" fill="currentColor" />
      <path
        d="M10.1 10.8165C9.94163 10.8165 9.7833 10.7582 9.6583 10.6332C9.41663 10.3915 9.41663 9.9915 9.6583 9.74984L12.825 6.5665C13.0666 6.32484 13.4666 6.32484 13.7083 6.5665C13.95 6.80817 13.95 7.20817 13.7083 7.44984L10.5416 10.6332C10.4166 10.7498 10.2583 10.8165 10.1 10.8165Z"
        fill="currentColor"
      />
    </svg>
  );
}
